import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ChatApiService } from '../../services/features/chat/chat-api.service';
import { AuthService } from '../../services/shared/auth.service';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';

interface Chat {
  originalName: string;
  username: string;
  unreadCount: number;
  selected: boolean;
  userId: string;
}

interface LikedUser {
  name: string;
  username: string;
  avatar?: string;
  userId: string;
}

@Component({
  selector: 'app-pre-chats',
  standalone: true,
  imports: [CommonModule, FormsModule, SpinnerComponent],
  templateUrl: './pre-chats.component.html',
  styleUrl: './pre-chats.component.scss'
})
export class PreChatsComponent implements OnInit {
  constructor(
    public router: Router,
    private chatApi: ChatApiService,
    private authService: AuthService
  ) { }

  activeTab: 'conversations' | 'liked' = 'conversations';
  previousChats: Chat[] = [];
  likedUsers: LikedUser[] = [];
  selectAll = false;
  spinner: boolean = false;
  spinMessage: string = '';
  ngOnInit() {
    this.fetchConversations();
    this.fetchLikedUsers();
  }

  fetchConversations() {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    this.spinner = true;
    this.spinMessage = 'Loading conversations...';

    this.chatApi.getConversations(token).subscribe((res: any) => {
      this.previousChats = (res.conversations || []).map((chat: any) => ({
        originalName: chat.originalName,
        username: chat.username,
        unreadCount: chat.unreadCount,
        selected: false,
        userId: chat.userId
      }));
      this.spinner = false;
      this.spinMessage = '';
    },
      (err) => {
        this.spinner = false;
        this.spinMessage = '';
      }
    );
  }

  fetchLikedUsers() {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    this.spinner = true;
    this.spinMessage = 'Loading liked users...';

    this.authService.getUserPreferences(token).subscribe((res: any) => {
      this.likedUsers = (res.likedUsers || []).map((user: any) => ({
        name: user.originalName,
        username: user.username,
        avatar: user.avatar,
        userId: user._id
      }));
      this.spinner = false;
      this.spinMessage = '';
    },

      (err) => {
        this.spinner = false;
        this.spinMessage = '';
      }
    );

  }

  goToChat(user: Chat | LikedUser) {
    this.router.navigate(['/chat', user.userId], {
      queryParams: { from: 'prechats' }
    });
  }

  goToUserProfile(user: LikedUser) {
    this.router.navigate(['/profile', user.userId]);
  }

  toggleSelectAll() {
    this.previousChats.forEach(chat => chat.selected = this.selectAll);
  }

  onChatSelectChange() {
    this.selectAll = this.previousChats.every(chat => chat.selected);
  }

  deleteSelected() {
    const token = sessionStorage.getItem('token');
    if (!token) return;
    const userIdsToDelete = this.previousChats.filter(chat => chat.selected).map(chat => chat.userId);
    if (userIdsToDelete.length === 0) return;

      this.spinner = true;
  this.spinMessage = 'Deleting selected conversations...';

    this.chatApi.deleteConversations(userIdsToDelete, token).subscribe(() => {
      this.previousChats = this.previousChats.filter(chat => !chat.selected);
      this.selectAll = false;
       this.spinner = false;
      this.spinMessage = '';
    },
  
      (err) => {
        this.spinner = false;
        this.spinMessage = '';
    });
  }

  dislikeUser(user: LikedUser) {
    const token = sessionStorage.getItem('token');
    if (!token) return;
    
      this.spinner = true;
  this.spinMessage = `Loading liked users...`;

    this.authService.dislikeUser(user.userId, token).subscribe(() => {
      this.likedUsers = this.likedUsers.filter(u => u.userId !== user.userId);
         this.spinner = false;
      this.spinMessage = '';
    },
      (err) => {
        this.spinner = false;
        this.spinMessage = '';
    });
  }

  trackByUserId(index: number, user: any) {
    return user.userId;
  }

  trackByChatUserId(index: number, chat: any) {
    return chat.userId;
  }
}